import type { PlatformMeResponse } from '@/types/api/auth'
import type { SuperadminSession } from '@/types/domain'

export function mapPlatformMeToSession(
  profile: PlatformMeResponse,
): SuperadminSession {
  return {
    id: profile.id,
    email: profile.email,
    displayName: profile.name,
    role: profile.role,
    isActive: profile.isActive,
  }
}
